import { render, staticRenderFns } from "./AddNewPost.vue?vue&type=template&id=1b34f75b&"
import script from "./AddNewPost.vue?vue&type=script&lang=js&"
export * from "./AddNewPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports